import { render, staticRenderFns } from "./deanCodeCopy.vue?vue&type=template&id=04bd3235&scoped=true"
import script from "./deanCodeCopy.vue?vue&type=script&lang=ts"
export * from "./deanCodeCopy.vue?vue&type=script&lang=ts"
import style0 from "./deanCodeCopy.vue?vue&type=style&index=0&id=04bd3235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bd3235",
  null
  
)

export default component.exports